/*
* @parameter {Array<Category>} categoriesArray: The flat array of all the categories
* @returns { key: String, value: Category }: The hash table whose keys are the categoryKey from the array above, and whose values are the corresponding categories 
*/
export const categoriesToHashTable = (categoriesArray) => {
    if (!categoriesArray) {
      return {}
    } else {
      const categoryIDToObjectMapper = {}
      
      categoriesArray.forEach((category) => {
        categoryIDToObjectMapper[category.categoryKey] = category
      })

      return categoryIDToObjectMapper
  }
}